import { configureStore as configureReduxStore } from '@reduxjs/toolkit';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { History } from 'history';
import { combineReducers } from 'redux';
import { thunk } from 'redux-thunk';

import { reducer as accountIntentSummaryReducer } from '../components/AccountLinkIntentSummary';
import { reducer as checkOutSummaryReducer } from '../components/CheckOutSummary';
import { reducer as getDetailsFromReducer } from '../components/GetDetailsFromRoute';
import { reducer as globalLoadingIndicator } from '../components/GlobalLoadingIndicator';
import { reducer as startupConfigReducer } from '../components/StartupConfig';
import { reducer as accountSelectionReducer } from '../pages/AccountSelection';
import { reducer as linkAccountLoginReducer } from '../pages/LinkAccountLogin';
import { reducer as linkAccountSelectionReducer } from '../pages/LinkAccountSelection';
import { reducer as loginReducer } from '../pages/Login';

const createRootReducer = (history: History) =>
  // @ts-expect-error TODO: Fix this type error
  combineReducers({
    router: connectRouter(history),
    ...startupConfigReducer,
    ...globalLoadingIndicator,
    ...checkOutSummaryReducer,
    ...loginReducer,
    ...linkAccountLoginReducer,
    ...accountSelectionReducer,
    ...getDetailsFromReducer,
    ...accountIntentSummaryReducer,
    ...linkAccountSelectionReducer,
  });

const rootReducer = (history: History) => (state: any, action: any) => {
  let appState = state;
  if (action.type.indexOf('GLOBAL_RESET') > -1 || history.location.pathname === '/logout') {
    appState = undefined;
  }

  return createRootReducer(history)(appState, action);
};

export default function configureStore(history: History, initialState?: any) {
  return configureReduxStore({
    reducer: rootReducer(history),
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(thunk, routerMiddleware(history)),
    preloadedState: initialState,
    devTools: { trace: true, traceLimit: 25 },
  });
}
